<p-toast
    [position]="position()"
    [life]="life()"
    [key]="key()"
    [preventDuplicates]="preventDuplicates()"
    [breakpoints]="breakpoints()"
    (onClose)="onClose($event)"
>
    @if (messageTemplate(); as tpl) {
        <ng-template #message let-message>
            <ng-container *ngTemplateOutlet="tpl; context: { $implicit: message }" />
        </ng-template>
    } @else {
        <ng-template #message let-message>
            <div class="p-toast-message-content">
                @if (message.icon) {
                    <pn-icon [name]="message.icon" class="p-toast-message-icon" />
                } @else {
                    <pn-icon name="info" class="p-toast-message-icon"></pn-icon>
                }
                <div class="p-toast-message-text">
                    @if (message.summary) {
                        <div class="p-toast-summary">{{ message.summary }}</div>
                    }
                    @if (message.detail) {
                        <div class="p-toast-detail">{{ message.detail }}</div>
                    }
                </div>
            </div>
        </ng-template>
    }

    @if (headlessTemplate(); as tpl) {
        <ng-template #headless let-message let-closeFn="closeFn">
            <ng-container *ngTemplateOutlet="tpl; context: { $implicit: message, closeFn: closeFn }" />
        </ng-template>
    }
</p-toast>
